import { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import Cookies from 'universal-cookie';
import data from '../../data/config.json'
import { useNavigate } from "react-router-dom";

export function useCookies() {
  const [cookies_loading, setLoading] = useState(false);
  const search = useLocation().search;
  const navigate = useNavigate()

  useEffect(() => {
    setLoading(true)
    const cookies = new Cookies()
    const token = new URLSearchParams(search).get('connect-token')
    const expires = new URLSearchParams(search).get('expires')
    const expires_data = new Date(Number(expires)) 
    if (!cookies.get('connect.dreamvast') && token) {
      cookies.set('connect.dreamvast', token, { path: '/', secure: data.secure, expires: expires_data });
      setLoading(false)  
      window.location.reload();
      navigate('/menu')
    }
    setLoading(false)  
  }, [search, navigate]);

  return { cookies_loading };
}